import Lookup from 'src/componentes/select-async';

const Uf = ({ ...rest }) => (
  <Lookup labelKey="descricao" valueKey="id" url="/UfLookup" {...rest} />
);

export default Uf;
